module.exports = __webpack_public_path__ + "img/nosotros_16-9_1920.e9c9717f.webp";